import {SidebarPageLayout} from '@github-ui/layout-primitives/SidebarPageLayout'
import {Link} from '@github-ui/react-router'
import {useRepoIssuesSidebarLayoutEnabled} from '@github-ui/repo-issues-page-layout/useSidebarLayoutEnabled'
import {Button, Heading} from '@primer/react'

import {LABELS} from './constants/labels'
import type {RepositoryResult} from './repository-milestone-index-page-query-types'
import styles from './RepositoryMilestone.module.css'

export type MilestonesActionsFragment = Pick<RepositoryResult, 'viewerCanCreateMilestones' | 'nameWithOwner'>

type MilestonesActionsProps = {
  repository: MilestonesActionsFragment
}

export function MilestonesActions({repository: {viewerCanCreateMilestones, nameWithOwner}}: MilestonesActionsProps) {
  const newMilestoneUrl = `/${nameWithOwner}/milestones/new`

  if (useRepoIssuesSidebarLayoutEnabled()) {
    return null
  }

  return (
    <div className={styles.buttonGrp}>
      <div className={styles.titleGroup}>
        <SidebarPageLayout.SidebarTrigger />
        <Heading as="h1" className={styles.heading}>
          Milestones
        </Heading>
      </div>

      {viewerCanCreateMilestones ? (
        <div className={styles.actionsGrp}>
          {/* Link hard-navigates to hand off to the Data Router app when /milestones/new
              isn't registered here (flag on); soft-navigates otherwise. */}
          <Button as={Link} to={newMilestoneUrl} variant="primary" data-testid="new-milestone-button">
            {LABELS.newMilestone}
          </Button>
        </div>
      ) : null}
    </div>
  )
}
